//@ts-check

class PaymentAuthorisationService {
	/*@ngInject*/
	constructor($http, Utility, $timeout, $rootScope, ContentService, BuildingsService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.BuildingsService = BuildingsService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.bandsData = {};
		this.InternalLinksService.getLinks('/api/paymentAuthorisation/links');
	}

	async getPaymentAuthorisation(schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}

			let url = await this.InternalLinksService.getLink('PaymentAuthorisationApi');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/paymentAuthorisation/links');
				url = await this.InternalLinksService.getLink('PaymentAuthorisationApi');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();

			const headers = this.Utility.headersWithContentType;

			const results = await this.$http.get(url, { headers });
			results.data.WebPortfolio = results.data.hasOwnProperty('WebPortfolio')
				? results.data.WebPortfolio
				: results.data.Portfolios;

			this.bandsData = {
				WebPortfolio: results.data.Portfolios,
				Comments: results.data.Comments,
				Status: results.data.Status,
				ContractualPayments: results.data.ContractualPayments
			};

			this.$timeout(() => promiseHandler.resolve());
		} catch (err) {
			this.bandsData = {
				WebPortfolio: [],
				Comments: [],
				Status: undefined,
				ContractualPayments: []
			};
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async approvePaymentAuthorisation(schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}

			let url = await this.InternalLinksService.getLink('PaymentAuthorisationApiApprove');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/paymentAuthorisation/links');
				url = await this.InternalLinksService.getLink('PaymentAuthorisationApiApprove');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();
			const results = await this.$http.post(url);
			const { data } = results;
			await this.getPaymentAuthorisation(schemeRef);
			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async approveContractualPayments(contractualPaymentIDs, schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!(contractualPaymentIDs && contractualPaymentIDs.length > 0)) {
				throw new Error('Contractual Payment IDs must be  supplied.');
			}
			if (!schemeRef || schemeRef['length'] < 3) {
				throw new Error('No Building reference provided...');
			}

			let url = await this.InternalLinksService.getLink('ContractualPaymentsApiBulkApprove');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/contractualpayments/links');
				url = await this.InternalLinksService.getLink('ContractualPaymentsApiBulkApprove');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();
			const headers = this.Utility.headersWithContentType;
			const payload = {
				PaymentIds: contractualPaymentIDs
			};

			const results = await this.$http.post(url, payload, { headers });
			await this.getPaymentAuthorisation(schemeRef);
			this.$timeout(() => promiseHandler.resolve(results));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async approveContractualPayment(id) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!id) {
				throw new Error('No Contractual Payment Id provided...');
			}

			let url = await this.InternalLinksService.getLink('ContractualPaymentsApiApprove');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/contractualpayments/links');
				url = await this.InternalLinksService.getLink('ContractualPaymentsApiApprove');
			}

			url = url.replace('{contractualPaymentId}', id);

			const results = this.$http.post(url);
			const { data } = results;

			const schemeRef = this.BuildingsService.getSelectedBuildingRef();
			await this.getPaymentAuthorisation(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async unApproveContractualPayment(id) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!id) {
				throw new Error('No Contractual Payment Id provided...');
			}

			let url = await this.InternalLinksService.getLink('ContractualPaymentUnApprove');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/contractualpayments/links');
				if (!url) url = await this.InternalLinksService.getLink('ContractualPaymentUnApprove');
			}

			url = url.replace('{contractualPaymentId}', id);

			const results = await this.$http.post(url);
			const { data } = results;

			const schemeRef = this.BuildingsService.getSelectedBuildingRef();
			await this.getPaymentAuthorisation(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async queryContractualPayment(id, message) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!id) {
				throw new Error('No Contractual Payment Id provided...');
			}
			if (!message) {
				throw new Error('No Query message provided...');
			}

			let url = await this.InternalLinksService.getLink('ContractualPaymentsApiQuery');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/contractualpayments/links');
				url = await this.InternalLinksService.getLink('ContractualPaymentsApiQuery');
			}

			const payload = {
				PaymentId: id,
				Message: message
			};

			const results = this.$http.post(url, payload);
			const { data } = results;

			const schemeRef = this.BuildingsService.getSelectedBuildingRef();
			await this.getPaymentAuthorisation(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async queryPaymentAuthorisation(schemeRef, message) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}
			if (!message) {
				throw new Error('No Query message provided...');
			}

			let url = await this.InternalLinksService.getLink('PaymentAuthorisationApiQuery');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/paymentAuthorisation/links');
				url = await this.InternalLinksService.getLink('PaymentAuthorisationApiQuery');
			}

			url = url.replace('{schemeRef}', schemeRef).trim();
			const payload = {
				SchemeRef: schemeRef,
				Message: message
			};

			const results = await this.$http.post(url, payload);
			const { data } = results;

			await this.getPaymentAuthorisation(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}
}

export default /* @ngInject */ (
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	BuildingsService,
	InternalLinksService
) =>
	new PaymentAuthorisationService(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		BuildingsService,
		InternalLinksService
	);
